export const isRequired = (fieldName: any) => `O campo ${fieldName} é obrigatório`;

export const maxLength = (length: any) => {
  return (fieldName: any) => `O campo ${fieldName} deve ter no máximo ${length} caracteres`;
};

export const minLength = (length: any) => {
  return (fieldName: any) => `O campo ${fieldName} deve ter pelo menos ${length} caracteres`;
};

export const arrayMinLength = (length: any) => {
  return (fieldName: any) => `O campo ${fieldName} deve ter pelo menos ${length} item(s)`;
};
export const arrayMaxLength = (length: any) => {
  return (fieldName: any) => `O campo ${fieldName} deve ter no máximo ${length} item(s)`;
};
export const isEmail = () => {
  return () => 'O e-mail informado é inválido';
};
export const isUrl = () => {
  return (fieldName: any) => `O campo ${fieldName} não é uma url válida`;
};
export const isSunUrl = () => {
  return (fieldName: any) => `O campo ${fieldName} não pode ser um link direto para o checkout`;
};
export const minimun = (min: any) => {
  return (fieldName: any) => `O valor de ${fieldName} tem que ser no mínimo ${min}`;
};

export const maximum = (max: any) => {
  return (fieldName: any) => `O valor de ${fieldName} tem que ser no máximo ${max}`;
};

export const supportEmailEduzzDomain = (): ((fieldName: string) => string) => {
  return () => 'O e-mail de suporte não pode ser do domínio Eduzz (@eduzz.com, @eduzz.com.br)';
};
